import { render } from "./WebmasterHeaderUserMenu.vue?vue&type=template&id=48f79d3c"
import script from "./WebmasterHeaderUserMenu.vue?vue&type=script&lang=js"
export * from "./WebmasterHeaderUserMenu.vue?vue&type=script&lang=js"

import "./WebmasterHeaderUserMenu.vue?vue&type=style&index=0&id=48f79d3c&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__